import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Siyaanishlogo1.png';

import { Instagram, Mail, AtSign } from 'lucide-react';
import { FaPinterestP, FaReddit } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-[#E5E0D8] mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img
            src={logo}
            alt="logo"
            className="h-16 w-auto transition-transform duration-300 group-hover:scale-105 bg-transparent"
          />
            <p className="text-sm text-[#6B665F] leading-relaxed font-light">
  Live Your Values.<br />
  Ethical luxury fashion for the conscious soul.<br />
  <span className="font-semibold ">GSTIN:</span> 36AFVFS7600E1ZO
</p>
            <div className="flex gap-4 pt-2">
  <a
    href="https://www.instagram.com/siyaanishofficial/"
    className="text-bronze hover:text-yellow-700-dark transition-colors"
    aria-label="Instagram"
    data-testid="footer-instagram"
  >
    <Instagram size={20} />
  </a>

  <a
    href="threads.com/@siyaanishofficial?igshid=NTc4MTIwNjQ2YQ%3D%3D"
    className="text-bronze hover:text-yellow-700-dark transition-colors"
    aria-label="Threads"
    data-testid="footer-threads"
  >
    <AtSign size={20} />
  </a>

  <a
    href="https://www.reddit.com/user/siyaanishofficial/?utm_source=share&utm_medium=mweb3x&utm_name=mweb3xcss&utm_term=1&utm_content=share_button"
    className="text-bronze hover:text-yellow-700-dark transition-colors"
    aria-label="Reddit"
    data-testid="footer-reddit"
  >
    <FaReddit size={20} />
  </a>

  <a
    href="mailto:info@siyaanish.com"
    className="text-bronze hover:text-yellow-700-dark transition-colors"
    aria-label="Email"
    data-testid="footer-email"
  >
    <Mail size={20} />
  </a>

  <a
    href="https://pin.it/4VtbHdQPx"
    className="text-bronze hover:text-yellow-700-dark transition-colors"
    aria-label="Pinterest"
    data-testid="footer-pinterest"
  >
    <FaPinterestP size={20} />
  </a>
</div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-serif text-lg mb-6 text-charcoal">Shop</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/shop?category=women" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-women">
                  Women
                </Link>
              </li>
              <li>
                <Link to="/shop?category=men" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-men">
                  Men
                </Link>
              </li>
              <li>
                <Link to="/shop?category=homeware" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-homeware">
                  Homeware
                </Link>
              </li>
              <li>
                <Link to="/shop?category=limited" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-limited">
                  Limited Batch
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="font-serif text-lg mb-6 text-charcoal">Information</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/return-order" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-return-order">
                  Return Order
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-track">
                  Track Order
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="font-serif text-lg mb-6 text-charcoal">Policies</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-terms">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/shipping-policy" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-shipping">
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link to="/return-policy" className="text-[#6B665F] hover:text-yellow-700 transition-colors font-light" data-testid="footer-link-returns">
                  Return & Refund
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#E5E0D8] mt-12 pt-8 text-center">
          <p className="text-xs text-[#6B665F] font-light tracking-wide">
            © 2025 Siyaanish. All rights reserved. Made with care for people and planet.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;